import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[660px] md:min-h-[800px] w-full overflow-hidden bg-deep-charcoal">
      {/* Background Image with Ken Burns Effect */}
      <motion.div 
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, ease: "linear" }}
        className="absolute inset-0 z-0 bg-cover bg-no-repeat" 
        style={{
          backgroundImage: "url('https://ik.imagekit.io/aeu02xvjgn/Ad%20Images/220609_W_Newmann-0496.jpg?updatedAt=1778006802941')",
          backgroundPosition: 'center 35%'
        }}
      >
        {/* Refined Gradient Overlay */}
        <div 
          className="absolute inset-0 z-10" 
          style={{
            background: 'linear-gradient(0deg, rgba(47,43,40,0.85) 0%, rgba(47,43,40,0.4) 40%, rgba(47,43,40,0) 100%)'
          }}
        ></div>
      </motion.div>

      {/* Hero Content - Optimized for Mobile Viewports */}
      <div className="absolute inset-x-0 bottom-[10%] md:bottom-[12%] lg:bottom-[15%] z-20 flex flex-col items-center px-6 text-center text-vintage-white">
        <motion.div 
          initial={{ opacity: 0, y: 40 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-[1000px] w-full"
        >
          <span className="uppercase tracking-[0.6em] text-[9px] md:text-xs font-bold mb-4 md:mb-8 block text-warm-stone/90">
            Claremont, California
          </span>
          
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-9xl font-medium leading-[1] mb-6 md:mb-10 text-balance drop-shadow-2xl">
            A Setting for <br className="hidden sm:block" /> 
            <span className="italic font-light">Timeless Stories</span>
          </h1>

          <p className="text-sm md:text-lg lg:text-xl font-light leading-relaxed mb-10 md:mb-12 max-w-xl md:max-w-2xl mx-auto text-aged-ivory/80 drop-shadow-md px-4">
            Step into the Spanish Revival architecture and sun-drenched groves of Padua Weddings during a curated private walkthrough.
          </p>

          <div className="flex flex-col items-center gap-8 md:gap-12">
            <button 
              onClick={scrollToBooking} 
              className="group relative overflow-hidden bg-estate-bronze text-vintage-white px-10 py-5 md:px-14 md:py-6 uppercase tracking-[0.3em] text-[10px] md:text-xs font-bold transition-all duration-500 shadow-2xl hover:bg-olive-grove active:scale-95"
            >
              <span className="relative z-10 text-white">Book Your Private Tour</span>
            </button>
            
            {/* Animated Scroll Indicator - Hidden on small mobile to save space */}
            <motion.div 
              animate={{ y: [0, 10, 0] }} 
              transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
              className="hidden sm:block w-px h-12 md:h-20 bg-gradient-to-b from-estate-bronze to-transparent opacity-50"
            ></motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}